import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const checkPerms =
    () =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        const config = {
            headers: {
                Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
            },
        }
        const params = {
            userId: userData.smsAuth.userId,
        }

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/checkPerms', params, config)

            if (status === 'ok') {
                dispatch({
                    type: storeDispatchTypes.setUserPerms,
                    value: data,
                })
            }
        } catch (e) {
            console.error('checkPerms failed', e)
        }
    }

export default checkPerms
